module.exports = __webpack_public_path__ + "static/media/Sir-Ganga-Ram.f36dc200.jpg";